import React, { useState } from 'react';
import {
    Box, Typography, Paper, Chip, TextField, InputAdornment, IconButton, Dialog, DialogTitle, DialogContent,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import HotelIcon from '@mui/icons-material/Hotel';
import BlockIcon from '@mui/icons-material/Block';
import BuildIcon from '@mui/icons-material/Build';


const TotalInactiveBeds = ({ open, onClose, propId }) => {
    const [search, setSearch] = useState('');

    const beds = [
        {
            id: 1,
            bed: 'A-101',
            room: 'Room 101',
            floor: '1st Floor',
            reason: 'Maintenance',
            inactiveDate: '01/09/2026',
            status: 'Inactive',
        },
        {
            id: 2,
            bed: 'A-102',
            room: 'Room 101',
            floor: '1st Floor',
            reason: 'Repair',
            inactiveDate: '30/08/2026',
            status: 'Inactive',
        },
        {
            id: 3,
            bed: 'B-201',
            room: 'Room 201',
            floor: '2nd Floor',
            reason: 'Cleaning',
            inactiveDate: '28/08/2026',
            status: 'Inactive',
        },
        {
            id: 4,
            bed: 'B-202',
            room: 'Room 202',
            floor: '2nd Floor',
            reason: 'Maintenance',
            inactiveDate: '25/08/2026',
            status: 'Inactive',
        },
    ];

    const filteredBeds = beds.filter(
        (bed) =>
            bed.bed.toLowerCase().includes(search.toLowerCase()) ||
            bed.room.toLowerCase().includes(search.toLowerCase()) ||
            bed.reason.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '6px',
                    maxHeight: '90vh',
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: 1,
                    px: 2,
                    mb: 1,
                    borderBottom: '1px solid #e2e8f0',
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize: '1rem',
                            fontWeight: 700,
                            color: '#1e293b',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.7,
                        }}
                    >
                        <HotelIcon
                            sx={{
                                fontSize: 20,
                                color: '#d97706',
                            }}
                        />
                        Inactive Beds
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: '0.7rem',
                            color: '#64748b',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5,
                        }}
                    >
                        Currently inactive bed details
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip size="small" label={`${beds.length} Beds`}
                        sx={{
                            height: 26,
                            fontSize: '0.68rem',
                            fontWeight: 700,
                            color: '#d97706',
                            background: '#fff7ed',
                            border: '1px solid #fed7aa',
                        }}
                    />

                    <IconButton size="small" onClick={onClose}
                        sx={{
                            color: '#64748b',
                            '&:hover': {
                                color: '#dc2626',
                                background: '#fef2f2',
                            },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 19 }} />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 2 }}>
                <Grid container spacing={1} sx={{ mb: 1.5 }}>
                    {/* Total Beds */}
                    <Grid item xs={6} md={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1,
                                borderRadius: '8px',
                                background: '#f8fafc',
                                border: '1px solid #e2e8f0',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '0.65rem',
                                    color: '#64748b',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                }}
                            >
                                <HotelIcon sx={{ fontSize: 15, color: '#64748b' }} />
                                Total Beds
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: '1.1rem',
                                    fontWeight: 700,
                                    color: '#334155',
                                    mt: 0.2,
                                    ml: 2
                                }}
                            >
                                125
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Inactive */}
                    <Grid item xs={6} md={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1,
                                borderRadius: '8px',
                                background: '#fff7ed',
                                border: '1px solid #fed7aa',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '0.65rem',
                                    color: '#9a3412',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                }}
                            >
                                <BlockIcon sx={{ fontSize: 15, color: '#d97706' }} />
                                Inactive
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: '1.1rem',
                                    fontWeight: 700,
                                    color: '#d97706',
                                    mt: 0.2,
                                    ml: 2
                                }}
                            >
                                {beds.length}
                            </Typography>
                        </Paper>
                    </Grid>

                    {/* Maintenance */}
                    <Grid item xs={6} md={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1,
                                borderRadius: '8px',
                                background: '#eff6ff',
                                border: '1px solid #dbeafe',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '0.65rem',
                                    color: '#2563eb',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5,
                                }}
                            >
                                <BuildIcon sx={{ fontSize: 15, color: '#2563eb' }} />
                                Maintenance
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: '1.1rem',
                                    fontWeight: 700,
                                    color: '#2563eb',
                                    mt: 0.2,
                                    ml: 2
                                }}
                            >
                                2
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>

                {/* Search */}
                <TextField
                    size="small"
                    fullWidth
                    placeholder="Search bed, room or reason..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{
                        mb: 1.5,
                        '& .MuiInputBase-root': {
                            height: 36,
                            fontSize: '0.75rem',
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon
                                    sx={{
                                        fontSize: 18,
                                        color: '#94a3b8',
                                    }}
                                />
                            </InputAdornment>
                        ),
                    }}
                />

                {/* Table */}
                <TableContainer component={Paper} elevation={0}
                    sx={{
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                        maxHeight: 400,
                        overflow: 'auto',
                    }}
                >
                    <Table stickyHeader size="small"
                        sx={{
                            minWidth: 650,

                            '& .MuiTableCell-root': {
                                py: 0.5,
                                px: 1,
                                fontSize: '0.7rem',
                                whiteSpace: 'nowrap',
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {['Bed', 'Room', 'Floor', 'Reason', 'Inactive Date', 'Status',].map((head) => (
                                    <TableCell key={head}
                                        sx={{
                                            fontWeight: 700,
                                            color: '#475569',
                                            background: '#f8fafc',
                                        }}
                                    >
                                        {head}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredBeds.map((bed) => (
                                <TableRow key={bed.id} hover>
                                    <TableCell
                                        sx={{
                                            fontWeight: 700,
                                            color: '#1e293b',
                                        }}
                                    >
                                        {bed.bed}
                                    </TableCell>

                                    <TableCell>{bed.room}</TableCell>
                                    <TableCell>{bed.floor}</TableCell>
                                    <TableCell>{bed.reason}</TableCell>
                                    <TableCell>{bed.inactiveDate}</TableCell>

                                    <TableCell>
                                        <Chip label="Inactive" size="small"
                                            sx={{
                                                height: 21,
                                                fontSize: '0.6rem',
                                                fontWeight: 700,
                                                color: '#d97706',
                                                background: '#fff7ed',
                                                border: '1px solid #fed7aa',
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}

                            {!filteredBeds.length && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center"
                                        sx={{
                                            py: 4,
                                            color: '#94a3b8',
                                            fontSize: '0.72rem',
                                        }}
                                    >
                                        No inactive beds found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default TotalInactiveBeds;
